export default {"src":"/_next/static/media/handelsblatt.02022d64.svg","height":32,"width":216,"blurWidth":0,"blurHeight":0};